import InputBase from '@mui/material/InputBase';
import Typography from '@mui/material/Typography';
import type { ChangeEvent, SyntheticEvent } from 'react';
import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(({ typography }) => ({
  container: {
    width: '100%',
  },
  inputRoot: {
    cursor: 'pointer',
    overflow: 'hidden',
  },
  marginLeft: {
    marginLeft: 20,
  },
  input: {
    textOverflow: 'ellipsis',
    fontSize: typography.fontSize,
  },
  hiddenSpan: {
    position: 'absolute',
    left: '100%',
    fontSize: typography.fontSize,
  },
}));

function Input({
  tagValue,
  onChange,
  onKeyDown,
  isEditing,
  placeholder = 'New Tag',
  id,
  hideHiddenSpan,
}: {
  tagValue: string;
  onChange: (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  onKeyDown: (e: SyntheticEvent) => void;
  isEditing: boolean;
  placeholder: string;
  id: string;
  hideHiddenSpan: boolean;
}) {
  const { classes, cx } = useStyles();
  const [width, setWidth] = useState(0);
  const spanRef = useRef<HTMLSpanElement | null>(null);
  const isNewTag = id === 'tag-0-new-field';

  useEffect(() => {
    const spanEl = spanRef.current;
    const minWidth = 65;
    let spanWidth = spanEl?.offsetWidth;
    spanWidth = spanWidth === 0 ? minWidth : (spanWidth || 0) + 40;
    setWidth(spanWidth);
  }, []);

  return (
    <div className={classes.container}>
      <InputBase
        id={id}
        readOnly={!isEditing}
        style={{ width }}
        autoFocus={isEditing}
        classes={{ root: classes.inputRoot, input: cx(classes.input, !isNewTag && classes.marginLeft) }}
        onChange={onChange}
        onKeyDown={onKeyDown}
        value={tagValue}
        autoComplete='one-time-code'
        placeholder={placeholder}
        inputProps={{
          maxLength: 32,
          name: 'tagValue',
        }}
      />
      <Typography
        ref={spanRef}
        className={classes.hiddenSpan}
        component='span'
        variant='bodyRegular'
        display='inline'
        style={{ visibility: hideHiddenSpan ? 'hidden' : 'visible' }}
      >
        {tagValue}
      </Typography>
    </div>
  );
}

export default Input;
